import { createFileRoute } from "@tanstack/react-router"
import { ProjectListSearchParams } from "@/features/project-editor/server/projectServer"
import { ProjectsList } from "@/features/projects/components"
import {
  applyProjectsListDefaults,
  approvedDuplicatesSummaryQuery,
  projectsListQuery,
} from "@/features/projects/core/hooks/useProjectsList"
import { getApiClient } from "@/lib/api"

export const Route = createFileRoute("/(authenticated)/projects/")({
  validateSearch: ProjectListSearchParams,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps: filters }) => {
    // Poke server, don't wait for it
    if (typeof window === "undefined") {
      void getApiClient()
        .GET("/api/hello")
        .catch((error) => {
          // Silently ignore errors - backend might not be running
          // This is just a "poke" to warm up the connection
          console.debug("Backend health check failed:", error)
        })
    }
    // Ensure the data is in the cache before render - don't wait for it.
    // Apply the same display defaults as the component so the loader's query
    // key matches and the cached fetch is reused.
    void context.queryClient.ensureQueryData(projectsListQuery(applyProjectsListDefaults(filters)))
    void context.queryClient.ensureQueryData(approvedDuplicatesSummaryQuery)
  },
  component: ProjectsList,
})
